import React, { useState } from 'react';
import { LayoutDashboard, MessageSquare, BarChart3, Settings, Search, Filter, Paperclip, Send } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { MessageModal } from '../../components/modals/MessageModal';
export function InquiriesPage() {
  const [message, setMessage] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: '',
    type: 'info' as 'success' | 'error' | 'info'
  });
  const [filterType, setFilterType] = useState('all');
  const handleSendMessage = () => {
    if (!message.trim()) {
      setModalContent({
        title: 'Empty Message',
        message: 'Please type a message before sending.',
        type: 'error'
      });
      setIsMessageModalOpen(true);
      return;
    }
    setModalContent({
      title: 'Message Sent',
      message: 'Your message has been sent successfully. The buyer will be notified.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
    setMessage('');
  };
  const handleAttachment = () => {
    setModalContent({
      title: 'Attach File',
      message: 'File attachment feature is coming soon. You will be able to attach documents, images, and PDFs.',
      type: 'info'
    });
    setIsMessageModalOpen(true);
  };
  const handleReportSpam = () => {
    setModalContent({
      title: 'Report Spam',
      message: 'This inquiry has been reported as spam. Our team will review it within 24 hours.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
  };
  const navItems = [{
    label: 'My Listings',
    icon: LayoutDashboard,
    path: '/dashboard/seller'
  }, {
    label: 'Inquiries',
    icon: MessageSquare,
    path: '/seller/inquiries',
    badge: '5'
  }, {
    label: 'Performance',
    icon: BarChart3,
    path: '/seller/performance'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/seller/settings'
  }];
  return <DashboardLayout title="Seller Dashboard" navItems={navItems} userInitials="RK" data-id="element-5543">
      <div className="flex flex-col h-[calc(100vh-140px)]" data-id="element-5544">
        <h1 className="text-2xl font-bold mb-6" data-id="element-5545">Inquiries</h1>

        <div className="flex flex-1 border border-gray-300 bg-white overflow-hidden" data-id="element-5546">
          {/* Inquiry List */}
          <div className="w-full md:w-1/3 border-r border-gray-300 flex flex-col" data-id="element-5547">
            <div className="p-4 border-b border-gray-300 bg-gray-50" data-id="element-5548">
              <div className="relative mb-3" data-id="element-5549">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-5550" />
                <input type="text" placeholder="Search messages..." className="w-full pl-9 pr-4 py-2 border border-gray-300 text-sm focus:outline-none focus:border-gray-500" data-id="element-5551" />
              </div>
              <div className="flex gap-2 overflow-x-auto pb-1" data-id="element-5552">
                <button onClick={() => setFilterType('all')} className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${filterType === 'all' ? 'bg-[#1f2933] text-white' : 'border border-gray-300 hover:bg-gray-100'}`} data-id="element-5553">
                  All
                </button>
                <button onClick={() => setFilterType('unread')} className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${filterType === 'unread' ? 'bg-[#1f2933] text-white' : 'border border-gray-300 hover:bg-gray-100'}`} data-id="element-5554">
                  Unread
                </button>
                <button onClick={() => setFilterType('pending')} className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${filterType === 'pending' ? 'bg-[#1f2933] text-white' : 'border border-gray-300 hover:bg-gray-100'}`} data-id="element-5555">
                  Pending
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto" data-id="element-5556">
              {[{
              name: 'Amit Patel',
              plot: 'Hinjewadi Plot',
              time: '2h ago',
              msg: 'Is the price negotiable?',
              active: true
            }, {
              name: 'Sarah Jenkins',
              plot: 'Wakad Land',
              time: '1d ago',
              msg: 'Can I see the documents?',
              active: false
            }, {
              name: 'Rahul Sharma',
              plot: 'Hinjewadi Plot',
              time: '2d ago',
              msg: 'When can I visit?',
              active: false
            }].map((chat, i) => <div key={i} className={`p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 ${chat.active ? 'bg-blue-50 border-l-4 border-l-blue-500' : ''}`} data-id="element-5557">
                  <div className="flex justify-between items-start mb-1" data-id="element-5558">
                    <span className="font-bold text-sm" data-id="element-5559">{chat.name}</span>
                    <span className="text-xs text-gray-400" data-id="element-5560">{chat.time}</span>
                  </div>
                  <div className="text-xs text-gray-500 font-mono mb-1" data-id="element-5561">
                    {chat.plot}
                  </div>
                  <p className="text-sm text-gray-600 truncate" data-id="element-5562">{chat.msg}</p>
                </div>)}
            </div>
          </div>

          {/* Chat Area */}
          <div className="hidden md:flex flex-col flex-1" data-id="element-5563">
            <div className="p-4 border-b border-gray-300 flex justify-between items-center bg-gray-50" data-id="element-5564">
              <div data-id="element-5565">
                <h3 className="font-bold" data-id="element-5566">Amit Patel</h3>
                <p className="text-xs text-gray-500" data-id="element-5567">
                  Interested in: Premium Corner Plot in Hinjewadi
                </p>
              </div>
              <button onClick={handleReportSpam} className="text-xs font-bold text-red-600 border border-red-200 bg-red-50 px-3 py-1 rounded hover:bg-red-100" data-id="element-5568">
                Report Spam
              </button>
            </div>

            <div className="flex-1 p-6 overflow-y-auto space-y-4 bg-[#f9f9fb]" data-id="element-5569">
              <div className="flex justify-start" data-id="element-5570">
                <div className="bg-white border border-gray-200 p-3 rounded-tr-lg rounded-br-lg rounded-bl-lg max-w-[80%]" data-id="element-5571">
                  <p className="text-sm text-gray-800" data-id="element-5572">
                    Hi, I'm interested in the Hinjewadi plot. Is the price
                    negotiable? Also, has the NA conversion been completed
                    recently?
                  </p>
                  <span className="text-[10px] text-gray-400 mt-1 block" data-id="element-5573">
                    10:30 AM
                  </span>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-5574">
                <div className="bg-[#1f2933] text-white p-3 rounded-tl-lg rounded-bl-lg rounded-br-lg max-w-[80%]" data-id="element-5575">
                  <p className="text-sm" data-id="element-5576">
                    Hello Amit. Yes, the price is slightly negotiable for
                    immediate closure. The NA conversion was done in 2023.
                  </p>
                  <span className="text-[10px] text-gray-400 mt-1 block text-right" data-id="element-5577">
                    10:45 AM
                  </span>
                </div>
              </div>
            </div>

            <div className="p-4 border-t border-gray-300 bg-white" data-id="element-5578">
              <div className="flex gap-2" data-id="element-5579">
                <button onClick={handleAttachment} className="p-2 text-gray-400 hover:text-gray-600" data-id="element-5580">
                  <Paperclip className="w-5 h-5" data-id="element-5581" />
                </button>
                <input type="text" placeholder="Type your reply..." value={message} onChange={e => setMessage(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSendMessage()} className="flex-1 border border-gray-300 p-2 text-sm focus:outline-none focus:border-gray-500 rounded-sm" data-id="element-5582" />
                <button onClick={handleSendMessage} className="p-2 bg-[#1f2933] text-white rounded-sm hover:bg-gray-800" data-id="element-5583">
                  <Send className="w-4 h-4" data-id="element-5584" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={modalContent.title} message={modalContent.message} type={modalContent.type} data-id="element-5585" />
    </DashboardLayout>;
}